// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList
}                         from '../../../../components';
import styles                 from './style';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import Dialog from 'material-ui/Dialog';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import AddExpense from '../../crud/addExpense'

class Expenses extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venue:props.statsTable.revenue_per_month.requested_venue_id,
      expense_data:[],
      expense_headers:[],
      expenses:true,
      add_expense:false
    };
    this.handleSelection = this.handleSelection.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  locationChanged() {
    this.setState({venue:this.props.statsTable.revenue_per_month.requested_venue_id}, () => {
      this.getExpense(); 
    })
  }

  getExpense() {
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=5102&venue_id=${this.state.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({expense_data:data.data,expense_headers:data.headers,venue:data.venue_id})
           // alert("fix");
       }).catch(error => error);
  }

  handleSelection(event){
    const name = event.target.name
    if(name == 'expenses'){
      this.setState({expenses:true,add_expense:false})
    }
    else if(name == 'add'){
      this.setState({add_expense:true,expenses:false})
    }
  }


  renderExpenses(){
    var venue = this.state.venue;
    if(this.state.expense_data.length == 0 && this.state.expense_headers.length == 0){
      this.getExpense()
    }
    
    return(
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>Expense By Month</div> 
        <table className="table_plain">
          <tr> 
            {this.state.expense_headers.map((head)=>
              <th>{head}</th>
            )
          }
          </tr>
          
            { this.state.expense_data && this.state.expense_data.length > 0 ?
              this.state.expense_data.map((data)=>
                <tr>
                  { data.map((each)=>
                    <td dangerouslySetInnerHTML={{__html:each}}></td>
                    )
                  }
                </tr>
                )
              :
              
              this.state.expense_headers.length > 0 ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '25%',left: '50%',width: '50%',height: '50%'}}> No Data Available</div>
              </div>
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
              </div>
              
            }
        </table>
      </div>
      )
  }

  

  
  render() {
    console.log('Expenses',this.props)
    if(this.state.venue != this.props.statsTable.revenue_per_month.requested_venue_id){
      this.locationChanged()
    }

    return(
      <div style={styles.container}>
        
          <div className='col-md-12'>
            <div className='col-md-12' style={{padding:'0px'}}>
              <button className='button1' style={{marginRight:'1%'}} onClick={this.handleSelection} name='expenses'> Expense Report </button>
              <button className='button1' style={{float:'right'}} onClick={this.handleSelection} name='add'> Add Expense </button>
             
            </div>
              
            <div className='col-md-12'>
              { this.state.expenses &&
                this.renderExpenses()
              }

              { this.state.add_expense &&
                <AddExpense/>
              }
            </div>

            
          </div>
        
      </div>
    );
  }
}

export default Expenses;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/crud/expenses/expenses.js